import { createSlice } from '@reduxjs/toolkit';

const updateUserAddressSlice = createSlice({
  name: 'updateUserAddress',
  initialState: {
    success: false,
    loading: false,
    userAddress: null,
    error: null,
  },
  reducers: {
    updateUserAddressRequest(state) {
      state.loading = true;
      state.error = null;
    },
    updateUserAddressSuccess(state, action) {
      state.loading = false;
      state.success = true;
      state.userAddress = action.payload;
    },
    updateUserAddressFailure(state, action) {
      state.loading = false;
      state.error = action.payload.message;
      state.success = false;
    },
    updateUserAddressReset(state) {
      return {...state, loading: false, userAddress: null, success:  false, error: null};
    }
  },
});

export const {
  updateUserAddressRequest,
  updateUserAddressSuccess,
  updateUserAddressFailure,
  updateUserAddressReset
} = updateUserAddressSlice.actions;

export default updateUserAddressSlice.reducer;
